import { Button } from "@/components/ui/button";
import { Step } from "../types";
import { SequenceHeader } from "../SequenceHeader";
import { LeadSelector } from "../LeadSelector";
import { SequenceStepsList } from "./SequenceStepsList";

interface SequenceFormProps {
  name: string;
  description: string;
  steps: Step[];
  selectedLeads: string[];
  isSaving: boolean;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onRemoveStep: (index: number) => void;
  onUpdateStep: (index: number, field: string, value: any) => void;
  onAddStep: () => void;
  onLeadsChange: (leads: string[]) => void;
  onSave: () => void;
}

export const SequenceForm = ({
  name,
  description,
  steps,
  selectedLeads,
  isSaving,
  onNameChange,
  onDescriptionChange,
  onRemoveStep,
  onUpdateStep,
  onAddStep,
  onLeadsChange,
  onSave
}: SequenceFormProps) => {
  return (
    <div className="space-y-6">
      <SequenceHeader
        name={name}
        description={description}
        onNameChange={onNameChange}
        onDescriptionChange={onDescriptionChange}
      />

      <SequenceStepsList
        steps={steps}
        onRemoveStep={onRemoveStep}
        onUpdateStep={onUpdateStep}
        onAddStep={onAddStep}
        isSaving={isSaving}
      />

      <LeadSelector 
        selectedLeads={selectedLeads}
        onLeadsChange={onLeadsChange}
      />

      <Button 
        onClick={onSave} 
        className="w-full"
        disabled={!name || !description || steps.length === 0 || isSaving}
      >
        {isSaving ? (
          <>
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary mr-2" />
            Saving...
          </>
        ) : (
          `Save Sequence ${selectedLeads.length > 0 ? '& Start' : ''}`
        )}
      </Button>
    </div>
  );
};